import { render, staticRenderFns } from "./HeaderSmall.vue?vue&type=template&id=22d2b06e&"
import script from "./HeaderSmall.vue?vue&type=script&lang=js&"
export * from "./HeaderSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports